// Restituisce il documento con i campi localizzati per la lingua corrente.
// L'italiano vive nei campi base; EN/ES in doc.translations[lang]. Fallback sempre all'italiano.
const TEXT_KEYS = ["title", "excerpt", "description", "location", "country", "dates_label", "role", "territory", "bio", "philosophy"];

// Come L(), ma per documenti con campi propri (pagine editoriali, sezioni, FAQ).
export function LT(doc, lang, keys) {
  if (!doc || !lang || lang === "it") return doc;
  const tr = (doc.translations || {})[lang] || {};
  const out = { ...doc };
  for (const k of keys) {
    if (tr[k]) out[k] = tr[k];
  }
  return out;
}

export function L(doc, lang) {
  if (!doc || !lang || lang === "it") return doc;
  const tr = (doc.translations || {})[lang] || {};
  const out = { ...doc };
  for (const k of TEXT_KEYS) {
    if (tr[k]) out[k] = tr[k];
  }
  if (Array.isArray(tr.itinerary) && tr.itinerary.length) out.itinerary = tr.itinerary;
  if (Array.isArray(tr.included) && tr.included.length) out.included = tr.included;
  if (Array.isArray(tr.excluded) && tr.excluded.length) out.excluded = tr.excluded;
  return out;
}
